import { querySelectorAll } from '../functions/querySelectors';

const VIDEO_POSTER = '/assets/img/svg/videoPoster.svg';

let videoClick = function(event) {
  this.play();
};

let autoplayVideo = function() {
  let videoElements = querySelectorAll('video.lazyload');

  videoElements.forEach((video) => {
    if (typeof video.getAttribute('poster') !== 'string') {
      video.setAttribute('poster', VIDEO_POSTER);
    }

    video.addEventListener('click', videoClick);

    let videoState = 0; // 0-nezapnuto, 1-play, 2-pause
    // eslint-disable-next-line no-undef
    let playObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            let promise = video.play();

            if (promise !== undefined) {
              promise.catch(_error => {
                // Auto-play was prevented
              });
            }

            videoState = 1;
            playObserver.unobserve(video);
          }
        });
      },
      {rootMargin: '0px 0px -10px 0px'});

    // eslint-disable-next-line no-undef
    let autoPauseObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio === 0 && !video.paused) {
          video.pause();
          videoState = 2;
        }
        else if (videoState === 2) {
          video.play();
          videoState = 1;
        }
      });
    }, {threshold: 0.01});

    // eslint-disable-next-line no-undef
    let img = new Image();
    img.src = VIDEO_POSTER;
    img.addEventListener('load', function() {
      playObserver.observe(video);
      autoPauseObserver.observe(video);
    });
  });
};

export function lazy() {
  autoplayVideo();

  let lazyImages = querySelectorAll('img.lazyload');

  lazyImages.forEach((image) => {
    image.setAttribute('loading', 'lazy');
    image.setAttribute('src', image.getAttribute('data-src'));
    image.classList.remove('lazyload');
  });
};
